module.exports = __webpack_public_path__ + "img/publish-i.aad5d63c.svg";